export const Green = "#4CB496";
export const Blue = "#228bec";
export const White = "#fff";
export const Black = "#000";
export const Brown = "#1d090a";
export const CyanGreen = "#5be2bb";
export const Red = "#FF6F61";
export const LightRed = "#f5857a";
export const Purple = "#654e9f";
